export const PHONE_DISPLAY = "(952) 393-0651";
export const PHONE_HREF = "tel:+19523930651";
export const EMAIL = "Roadside@Trunorthrecovery.com";

export const SERVICES = [
  {
    id: "jump-start",
    num: "01",
    label: "Jump Start",
    price: 90,
    suffix: "",
    icon: "BatteryCharging",
    blurb: "Dead battery? We'll get you back on the road.",
  },
  {
    id: "tire-change",
    num: "02",
    label: "Tire Change",
    price: 100,
    suffix: "",
    icon: "LifeBuoy",
    blurb: "Spare installation, lug nuts torqued, and basic check.",
  },
  {
    id: "tire-inflation",
    num: "03",
    label: "Tire Inflation / Minor Puncture Repair",
    price: 90,
    suffix: "",
    icon: "Gauge",
    blurb: "Get back on the road safely and quickly.",
    tooltip: "Low tire or slow leak? We air it up and patch minor punctures roadside — no tow needed.",
  },
  {
    id: "lockout",
    num: "04",
    label: "Car Lockout",
    price: 100,
    suffix: "",
    icon: "LockKeyhole",
    blurb: "Keys locked inside? We'll get you back in.",
  },
  {
    id: "fuel-delivery",
    num: "05",
    label: "Fuel Delivery",
    price: 90,
    suffix: "+ fuel",
    icon: "Fuel",
    blurb: "Out of gas? We'll bring you the fuel you need.",
  },
  {
    id: "battery-install",
    num: "06",
    label: "Battery Installation",
    price: 90,
    suffix: "",
    icon: "Battery",
    blurb: "Your battery, our install.",
    tooltip: "Already have the new battery? We come to you and install it — flat $90, terminals cleaned and tested.",
  },
  {
    id: "battery-delivery",
    num: "07",
    label: "Battery Delivery + Installation",
    price: 100,
    suffix: "+ battery",
    icon: "BatteryPlus",
    blurb: "We bring the battery, install it, and get you moving.",
    tooltip: "No battery yet? We bring the correct battery for your vehicle and install it on the spot — $100 plus the cost of the battery.",
  },
];

export const ALL_SERVICES = SERVICES.map((s) => ({
  id: s.id,
  label: s.label,
  price: s.price,
  suffix: s.suffix || "",
  note: s.tooltip || "",
}));

export const STATUSES = [
  { id: "waiting", label: "Waiting" },
  { id: "dispatched", label: "Dispatched" },
  { id: "en-route", label: "En Route" },
  { id: "on-scene", label: "On Scene" },
  { id: "completed", label: "Completed" },
];

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (typeof window !== "undefined" && window.__lenis && el) {
    window.__lenis.scrollTo(`#${id}`, { offset: -72, duration: 1.4 });
  } else if (el) {
    el.scrollIntoView({ behavior: "smooth" });
  } else {
    window.location.href = `/#${id}`;
  }
}
